import { css, cx } from "emotion";
import React from "react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import moment from "moment-timezone";

const HistoryItem = (props) => {
  var idLocale = require("moment/locale/id");
  moment.locale("id", idLocale);

  const { data } = props;
  const [dropdown, setDropdown] = React.useState(false);

  const toggleDropdown = () => {
    setDropdown(!dropdown);
  };

  return (
    <div className="card card-body rounded-8px p-3 border-1-secondary mb-3">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <p className="font-bold font-12 mb-1">
            {moment(data.group_date)
              .tz(process.env.REACT_APP_TIMEZONE)
              .format("dddd, DD MMMM YYYY")}
          </p>
          <span className="text-muted font-10">
            {data.billing_invoices.length} Activity
          </span>
        </div>
        <button
          type="button"
          className="btn border-0 pr-0"
          onClick={() => toggleDropdown()}
        >
          {dropdown && <ArrowDropUpIcon />}

          {!dropdown && <ArrowDropDownIcon />}
        </button>
      </div>
      <div
        className={dropdown ? "history-item-list" : "history-item-list d-none"}
      >
        {data.billing_invoices.map((val, index) => {
          return (
            <div
              className="d-flex justify-content-between align-items-start py-3 border-bottom-1-secondary"
              key={index}
            >
              <div className="pr-2">
                <span className="d-block font-10 text-muted mb-1">
                  <b className="text-primary">{val.tenant.name}</b> -{" "}
                  {val.tenant.property.name}
                </span>
                <span className="d-block font-9 text-muted mb-1">
                  Start Request{" "}
                  <b>
                    {moment(val.created_time)
                      .tz(process.env.REACT_APP_TIMEZONE)
                      .format("DD MMMM YYYY")}
                  </b>
                </span>
                {val.progress === "wait" && (
                  <span className="d-block font-9 text-muted mb-2">
                    Status : <b className="text-blue">Waiting</b>
                  </span>
                )}
                {val.progress === "process" && (
                  <span className="d-block font-9 text-muted mb-2">
                    Change to <b className="text-warning">Send to Xendit</b>
                  </span>
                )}
                {val.progress === "failed" && (
                  <span className="d-block font-9 text-muted mb-2">
                    Change to <b className="text-danger">Failed</b>
                  </span>
                )}
                {val.progress === "complete" && (
                  <span className="d-block font-9 text-muted mb-2">
                    Change to <b className="text-green">Complete</b>
                  </span>
                )}
                <span className="font-9 text-blue align-middle">
                  <FiberManualRecordIcon className="font-9" />{" "}
                  {val.bank_account.bank_account_name}
                </span>
              </div>
              <span className="text-muted font-9">
                {moment(
                  val.progress === "wait" ? val.created_time : val.updated_time
                )
                  .tz(process.env.REACT_APP_TIMEZONE)
                  .format("LT")}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HistoryItem;
